let options = {
    loadmoreSelector: '[data-tile-loadmore]',
    itemContainerSelector: '.reference-list.global-tile__row',
    itemSelector: '.reference-list__item'
};

const eventHandler = {
    isLoading: false,

    loadmore: (loadMoreElement) => {
        // prevent double click :-)
        if (eventHandler.isLoading) {
            return;
        }
        eventHandler.isLoading = true;
        loadMoreElement.querySelector('button').classList.add('button--loading');

        let uri = loadMoreElement.dataset.tileLoadmore;

        fetch(uri)
            .then(response => {
                return response.text()
            })
            .then(html => {
                let targetContainer = loadMoreElement.parentElement.querySelector(options.itemContainerSelector);

                let loadedDom = document.createElement("div");
                loadedDom.innerHTML = html;

                let loadedItems = loadedDom.querySelectorAll(options.itemSelector);
                let loadedLoadMoreElement = loadedDom.querySelector(options.loadmoreSelector);

                if (loadedItems) {
                    loadedItems.forEach(item => {
                        let image = item.querySelector("picture.sal-image");
                        if (image !== null) {
                            let sources = image.children;

                            for (let source of sources) {
                                if (source.tagName === "SOURCE") {
                                    source.srcset = source.dataset.src;
                                } else {
                                    source.src = source.dataset.src;
                                }
                            }

                            image.classList.remove('preview');
                        }
                        targetContainer.append(item);
                    });


                    // Replace load more button
                    if (loadedLoadMoreElement !== null) {
                        loadMoreElement.insertAdjacentElement('afterend', loadedLoadMoreElement);
                        loadedLoadMoreElement.querySelector('button').addEventListener('click', eventHandler.loadmore.bind(loadmore, loadedLoadMoreElement));
                    }
                }
                loadMoreElement.remove();

                eventHandler.isLoading = false;
            });
    }
};

const loadmore = {
    init: (overwriteOptions) => {
        options = Object.assign(options, overwriteOptions);
        const self = this;

        const loadMoreElements = document.querySelectorAll(options.loadmoreSelector);
        loadMoreElements.forEach(loadMoreElement => {
            loadMoreElement.querySelector('button').addEventListener('click', eventHandler.loadmore.bind(self, loadMoreElement));
        });
    }
};

export { loadmore };
